import { render, staticRenderFns } from "./SoloQuestion.vue?vue&type=template&id=0dccf4ef&"
import script from "./SoloQuestion.vue?vue&type=script&lang=ts&"
export * from "./SoloQuestion.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports